import { Link } from "react-router-dom";

export const FooterLinkColumn = ({ title, links, testIdPrefix }) => (
  <div>
    <p className="font-mono text-xs uppercase tracking-[0.2em] text-teal-500 dark:text-teal-400 mb-5">{title}</p>
    <ul className="grid grid-cols-1 gap-3">
      {links.map((link) => (
        <li key={link.path}>
          <Link
            data-testid={`${testIdPrefix}-${link.testId}`}
            to={link.path}
            className="text-slate-600 dark:text-slate-300 hover:text-slate-900 dark:hover:text-white transition-colors duration-300"
          >
            {link.label}
          </Link>
        </li>
      ))}
    </ul>
  </div>
);
